export default __webpack_public_path__ + "static/media/01_01.006423fa.jpg";